import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const UrbanizacionFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='URBANIZACIÓN' htmlFor='input-urbanizacion' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='urbanizacion'>
          {({ field }) => (
            <Form.InputText
              {...field}
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              id='input-urbanizacion'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(UrbanizacionFormGroup)
